<template>
  <div class="bg-white p-2 border rounded shadow-sm">
    <div class="font-semibold mx-2 my-2 text-gray-600">
      Network traffic heatmap
    </div>
    <div class="h-full">
      <div class="block">
        <div class="bg-white">
          <nav class="tabs flex flex-col sm:flex-row">
            <button data-target="panel-1" v-for="venue in venues" :key="venue.id" @click="venueId = venue.id"
                    :class="venueId == venue.id ? 'border-b-2 text-teal-500  border-teal-500' :''"
                    class="tab text-gray-600 py-4 px-6 block hover:text-teal-500 focus:outline-none font-medium">
              {{ venue.name }}
            </button>
          </nav>
        </div>
        <div class="w-full rounded-lg  overflow-hidden  mb-3" v-if="venueId !== ''">
          <LayoutDesigner :show-heat-map="true" :venue-id="venueId" :title="null"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LayoutDesigner from "@/modules/venues/LayoutDesigner";
import GraphQl from "@/services/graphql.service";

export default {
  name: "IndoorHeatmap",
  components: {LayoutDesigner},
  data() {
    return {
      venueId: '',
      venues: []
    }
  },
  props: {
    filters: Object,
    orgId: String
  },
  watch: {
    filters: {
      handler: function () {
        this.loadVenues()
      },
      deep: true
    }
  },
  computed: {},
  mounted() {
    this.loadVenues()
  },
  methods: {
    loadVenues() {
      if (this.filters.venues.length > 0)
        this.venues = this.filters.venues
      else
        GraphQl.sendRequest("{organization(id: \"" + this.orgId + "\"){venues{id name}}}")
            .then(response => {
              this.venues = response.organization.venues;
            })
      if (this.venues.length > 0)
        this.venueId = this.venues[0].id
    }
  }
}
</script>

<style scoped>

</style>